import { RootState } from "@src/reducers/store";
import { useSelector } from "react-redux";

export const useMachineStructurePanelControlBarHook = () => {
  const unassignedBlueprintNodeDataFiltered = useSelector(
    (state: RootState) => state.yourSlice.unassignedBlueprintNodeDataFiltered,
  );

  return {
    unassignedBlueprintNodeDataFiltered,
  };
};
